import React from "react";
import {
  AppBar,
  Toolbar,
  TextField,
  InputAdornment,
  IconButton,
  Box,
  useMediaQuery,
} from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { Menu as MenuIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import ProfileTrigger from "./InvestorProfilePopup";
import NotificationBell from "../NotificationBell";

import { dashboardShell } from "../../theme/dashboardShell";

const InvestorHeader = ({ onMenuClick }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <AppBar
      position="sticky"
      color="inherit"
      elevation={0}
      sx={{
        top: 0,
        zIndex: (t) => t.zIndex.drawer - 1,
        bgcolor: dashboardShell.surface.paper,
        borderBottom: dashboardShell.header.border,
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
          gap: 2,
          py: 1,
          minHeight: 64,
          px: { xs: 2, sm: 3 },
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0, display: "flex", alignItems: "center", gap: 1 }}>
          {!isMdUp && onMenuClick && (
            <IconButton
              aria-label="open menu"
              edge="start"
              onClick={onMenuClick}
              sx={{ color: "text.primary", flexShrink: 0 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <TextField
            fullWidth={isSm}
            placeholder="Search assets, properties, documents..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRoundedIcon sx={{ color: "text.secondary" }} />
                </InputAdornment>
              ),
              sx: {
                borderRadius: 2,
                bgcolor: dashboardShell.surface.search,
                maxWidth: { sm: 420, md: 480 },
                "& fieldset": { border: "none" },
              },
            }}
            size="small"
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
          <NotificationBell />
          <ProfileTrigger alignWithTopbar />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default InvestorHeader;
